import IAntiForgeryToken from '../models/auth/AntiForgeryToken';
import auth, { AuthTypes } from '../actions/auth';

export const AuthInitialState: IAuthState = {
  antiForgeryToken: {
    cookieName: null,
    tokenValue: null,
  },
};

export interface IAuthState {
  antiForgeryToken: IAntiForgeryToken;
}

export default function authReducer(state: IAuthState = AuthInitialState, action: AuthTypes): IAuthState {
  switch (action.type) {
    case auth.AntiForgeryToken.AUTH_SET_ANTI_FORGERY_TOKEN:
      return {
        ...state,
        antiForgeryToken: action.data,
      };

    default:
      return state;
  }
}
